module.exports = __webpack_public_path__ + "img/fotostrommen.785b60b8.jpg";